export default __webpack_public_path__ + "static/media/face7.9732da52.svg";